import { JSX } from 'react'

import { IconProps } from '../../icon'

const ChevronUp: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_46_120)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9603 30.5397C14.5739 31.1534 15.5689 31.1534 16.1826 30.5397L24.5 22.2223L32.8174 30.5397C33.4311 31.1534 34.4261 31.1534 35.0397 30.5397C35.6534 29.9261 35.6534 28.9311 35.0397 28.3174L25.6112 18.8888C24.9975 18.2752 24.0025 18.2752 23.3888 18.8888L13.9603 28.3174C13.3466 28.9311 13.3466 29.9261 13.9603 30.5397Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_46_120'>
        <rect width='48' height='48' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default ChevronUp
